var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',[_vm._v(_vm._s(_vm.display))]),_c('v-col',[_c('v-select',{attrs:{"outlined":"","dense":"","placeholder":_vm.placeholder,"items":_vm.itemSelectColumns,"hide-details":true},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }